import { propsFactory } from '@components/utils';

import type { NTree } from '@components/components';
import type { PropType } from 'vue';

export const makeTreeEventsProps = propsFactory(
  {
    onFocus: {
      type: Function as PropType<(event: FocusEvent) => void>,
      default: undefined
    },
    onBlur: {
      type: Function as PropType<(event: FocusEvent) => void>,
      default: undefined
    },
    onKeydown: {
      type: Function as PropType<NTree.TEventHandler>,
      default: undefined
    },
    onContextmenu: {
      type: Function as PropType<NTree.TEventHandler>,
      default: undefined
    },
    onClick: {
      type: Function as PropType<NTree.TNodeMouseEventHandler>,
      default: undefined
    },
    onDblclick: {
      type: Function as PropType<NTree.TNodeMouseEventHandler>,
      default: undefined
    },
    onScroll: {
      type: Function as PropType<NTree.TEventHandler>,
      default: undefined
    },
    onExpand: {
      type: Function as PropType<
        (
          expandedKeys: NTree.TKey[],
          info: { node: NTree.IEventDataNode; expanded: boolean; nativeEvent: MouseEvent }
        ) => void
      >,
      default: undefined
    },
    onCheck: {
      type: Function as PropType<
        (checked: { checked: NTree.TKey[]; halfChecked: NTree.TKey[] } | NTree.TKey[], info: NTree.ICheckInfo) => void
      >,
      default: undefined
    },
    onSelect: {
      type: Function as PropType<
        (
          selectedKeys: NTree.TKey[],
          info: {
            event: 'select';
            selected: boolean;
            node: NTree.IEventDataNode;
            selectedNodes: NTree.IDataNode[];
            nativeEvent: MouseEvent;
          }
        ) => void
      >,
      default: undefined
    },
    onLoad: {
      type: Function as PropType<
        (loadedKeys: NTree.TKey[], info: { event: 'load'; node: NTree.IEventDataNode }) => void
      >,
      default: undefined
    },
    onMouseenter: {
      type: Function as PropType<(info: NTree.TNodeMouseEventParams) => void>,
      default: undefined
    },
    onMouseleave: {
      type: Function as PropType<(info: NTree.TNodeMouseEventParams) => void>,
      default: undefined
    },
    onRightClick: {
      type: Function as PropType<(info: NTree.TNodeMouseEventParams) => void>,
      default: undefined
    },
    onDragstart: {
      type: Function as PropType<(info: NTree.TNodeDragEventParams) => void>,
      default: undefined
    },
    onDragenter: {
      type: Function as PropType<(info: NTree.TNodeDragEventParams & { expandedKeys: NTree.TKey[] }) => void>,
      default: undefined
    },
    onDragover: {
      type: Function as PropType<(info: NTree.TNodeDragEventParams) => void>,
      default: undefined
    },
    onDragleave: {
      type: Function as PropType<(info: NTree.TNodeDragEventParams) => void>,
      default: undefined
    },
    onDragend: {
      type: Function as PropType<(info: NTree.TNodeDragEventParams) => void>,
      default: undefined
    },
    onDrop: {
      type: Function as PropType<
        (
          info: NTree.TNodeDragEventParams & {
            dragNode: NTree.IEventDataNode | null;
            dragNodesKeys: NTree.TKey[];
            dropPosition: number;
            dropToGap: boolean;
          }
        ) => void
      >,
      default: undefined
    },
    onActiveChange: {
      type: Function as PropType<(key: NTree.TKey | null) => void>,
      default: undefined
    }
  },
  'tree-events'
);
